import script from "./JobOverViewSidePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./JobOverViewSidePanel.vue?vue&type=script&setup=true&lang=js"

import "./JobOverViewSidePanel.vue?vue&type=style&index=0&id=18d44562&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18d44562"]])

export default __exports__